import { GoogleAuthProvider } from "firebase/auth";
import React from "react";
import { useContext } from "react";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { FaGoogle, FaGithub } from "react-icons/fa";
import { AuthContext } from "../../../context/AuthProvider/AuthProvider";

const RightSideBar = () => {
  const { googleSignin } = useContext(AuthContext);
  const googleProvider = new GoogleAuthProvider();

  const handlegoogleSignin = () => {
    googleSignin(googleProvider)
      .then((result) => {
        const user = result.user;
        console.log(user);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <ButtonGroup vertical>
        <Button onClick={handlegoogleSignin} className="mb-2">
          Login with google <FaGoogle></FaGoogle>{" "}
        </Button>
        <Button className="mb-2">
          login with github <FaGithub></FaGithub>
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default RightSideBar;
